export default {
  eyebrow: 'Portal partnera',
  title: 'Podatki i waluta',
  description: 'Domyślne kategorie podatkowe dziedziczone przez restauracje, chyba że indywidualnie je nadpiszą.',
};
